import Vue from 'vue'
import {helpers} from './../../helpers';

export default {
    store: {
        namespaced: true,
        state: {
            current: {},
            logedIn: false,
            groups: [],
            users: [],
            currentUsersPage: 1
        },
        mutations: {
            setCurrentUsersPage(state, page) {
                if (page) state.currentUsersPage = page;
            },
            unshiftUser(state, user) {
                state.users.unshift(user);
            },
        },
        actions: {
            searchUsers({ rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/user', {params: data}).then(r => r ? r.data : null);
            },

            getUsers({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/user', {params: data}).then(r => {
                    if (!r) return [];
                    Vue.set(state, 'users', r.data);
                    Vue.set(state, 'users_amount', r.total);
                    return r.data;
                });
            },

            getCurrentUser({ rootState, state }) {
                return helpers.http.get({context: this, rootState}, '/user/current').then(r => {
                    if (!r) return false;
                    Vue.set(state, 'current', r);
                    Vue.set(state, 'logedIn', true);
                    this.dispatch('module/getAccessModules');
                    return r;
                }, () => {
                    Vue.set(state, 'current', {});
                    Vue.set(state, 'logedIn', false);
                    Vue.http.headers.common['Authorization'] = null;
                    return false;
                });
            },

            //получение всех групп пользователей
            getUsersGroups({ rootState, state }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/group', {params: data}).then(r => {
                    if (!r) return [];
                    Vue.set(state, 'groups', r.data);
                    Vue.set(state, 'groups_amount', r.total);
                    return r.data;
                });
            },

            //получение группы
            getUsersGroup({ rootState, state }, data) {
                return helpers.http.get({context: this, rootState}, '/group/' + data.groupCode).then(r => {
                    Vue.set(state, 'group', r);
                    return r;
                });
            },

            //логин пользователя
            login({ rootState, state }, data) {
                return helpers.http.post({context: this, rootState}, '/login', {
                    login:    data.login,
                    password: data.password,
                    login_auth: true
                }).then(r => {
                    if (!r) return;
                    Vue.http.headers.common['Authorization'] = r.token;
                    localStorage.setItem('id_token', r.token);
                    Vue.set(state, 'logedIn', true);
                    this.dispatch('module/getAccessModules');
                    return r;
                }, () => {
                    Vue.set(state, 'logedIn', false);
                    return false;
                });
            },

            authReset({ dispatch }) {
                dispatch('logout')
            },

            //разлогин пользователя
            logout({ rootState, state }) {
                return helpers.http.post({context: this, rootState}, '/logout').then(() => {
                    Vue.set(state, 'logedIn', false);
                    Vue.set(state, 'current', {});
                    Vue.http.headers.common['Authorization'] = null;
                    localStorage.removeItem('id_token');
                    localStorage.removeItem('refresh_token');
                    return;
                });
            },

            blockUser({ rootState }, id) {
                return helpers.http.post({context: this, rootState}, '/user/' + id + '/block');
            },

            unblockUser({ rootState }, id) {
                return helpers.http.post({context: this, rootState}, '/user/' + id + '/unblock');
            },

            authoffUser({ rootState }, id) {
                return helpers.http.post({context: this, rootState}, '/user/' + id + '/auth-off');
            },

            getUser({ rootState }, id) {
                return helpers.http.get({context: this, rootState}, '/user/id/' + id);
            },

            resetPassword({ rootState }, login) {
                return helpers.http.get({context: this, rootState}, '/user/' + login + '/return');
            },

            resetPasswordConfirm({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/user/reset', data);
            },

            //изменение пользователя
            putUser({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/user', data);
            },

            //добавление нового пользователя
            postUser({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/user', data);
            },

            //удаление пользователя
            removeUser({ rootState }, id) {
                return helpers.http.delete({context: this, rootState}, '/user/id/' + id);
            },

            //изменение группы пользователей
            putGroup({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/group', data);
            },
            //добавление новой группы пользователей
            postGroup({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/group', data);
            },
            //удаление группы
            removeGroup({ rootState }, id) {
                return helpers.http.delete({context: this, rootState}, '/group/' + id);
            },

            //проверка прав
            can({ rootState}, data) {
                return helpers.http.get({context: this, rootState}, '/user/' + data.user_login + '/can/' + data.action);
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/users/store.js